import { RouteObject } from "react-router";
import { Lazy } from "@shared/components/ui/lazy";

const Transmission = Lazy(() => import("@shared/features/transmission/pages/transmission"), "Transmission");
const TransmissionList = Lazy(() => import("@shared/features/transmission/pages/transmission-list"), "TransmissionList");

export interface TransmissionRoutesProps {
  useOrganization?: boolean;
}

export const getTransmissionRoutes = (
  props: TransmissionRoutesProps = {}
): RouteObject[] => {
  const { useOrganization } = props;
  return [
    {
      path: "transmissions",
      children: [
        {
          index: true,
          element: <TransmissionList useOrganization={useOrganization} />,
        },
        { path: ":id", element: <Transmission /> },
      ],
    },
  ];
};
